export default {
  // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
  bind: (el, binding) => {
    let str = binding.value
    let reg = /\$\^\S+\^\$/
    if (reg.test(str)) {
      str = str.replace(/\$\^/g, '<sup>')
      str = str.replace(/\^\$/g, '</sup>')
      // el.innerHTML = str
    } // else {
    // el.innerText = str
    // }
    el.innerHTML = str
    if (el.children.length > 0 && el.children[0].tagName === 'IMG') {
      el.children[0].style.maxWidth = '100%'
    }
    if (el.getElementsByTagName('img').length > 0) {
      for (let i = 0; i < el.getElementsByTagName('img').length; i++) {
        el.getElementsByTagName('img')[i].style.maxWidth = '100%'
      }
    }
    // console.log('bind', el.innerHTML)
  },
  // 被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
  inserted: (el) => {
    // console.log('inserted', el.innerHTML)
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update: (el) => {
    // console.log('update', el.innerHTML)
  },
  // 指令所在组件的 VNode 及其子 VNode 全部更新后调用。
  componentUpdated: (el, binding) => {
    let str = binding.value
    let reg = /\$\^\S+\^\$/
    if (reg.test(str)) {
      str = str.replace(/\$\^/g, '<sup>')
      str = str.replace(/\^\$/g, '</sup>')
      // el.innerHTML = str
    } // else {
    //   el.innerText = str
    // }
    el.innerHTML = str
    if (el.children.length > 0 && el.children[0].tagName === 'IMG') {
      el.children[0].style.maxWidth = '100%'
    }
    if (el.getElementsByTagName('img').length > 0) {
      for (let i = 0; i < el.getElementsByTagName('img').length; i++) {
        el.getElementsByTagName('img')[i].style.maxWidth = '100%'
      }
    }
    // console.log(str)
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind: (el) => {
    // console.log('unbind', el.innerHTML)
  }
}



// WEBPACK FOOTER //
// ./src/instruction/power.js